import React, { useEffect, useState } from 'react'
import axios from 'axios';


function FileUploadButton(props) {
    
    const [ project_id, setProject_id ] = useState(props.project_id);
    const [ type, setType ] = useState(props.type);
    const [ file, setFile ] = useState({});
    const checkFile = async(event) => {
        var date = new Date()
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var date = month + "-" + day + "-" + year;

        try{
            if(event.target.files[0].type === 'application/pdf' && 
                props.associatedGroupingType === "project" &&
                props.type === 'final_document' && 
                event.target.files.length > 0)
            {
                if(event.target.files[0].type !== 'application/pdf'){
                    event.target.value = null;
                    alert("Invalid File Type: Please Upload PDF files Only.");
    
                    return;
                }
                setFile(event.target.files[0])
                const formData = new FormData();
                formData.append('end_semester', props.group.project.end_semester);
                formData.append('year', year);
                formData.append('type', props.type);

                formData.append('file', event.target.files[0]);
                formData.append('filename', event.target.files[0].name);
                formData.append('filetype', event.target.files[0].type);
                formData.append('filesize', event.target.files[0].size);
                formData.append('hidden', 0);

                axios.post(`${process.env.REACT_APP_API_HOST}/api/file/uploadGroupFiles`,
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                        Authorization: `Bearer ${props.token.access_token}`,
                    },
                })        
                .then(res => props.filesLoaded(res.data.data[0], props.type))
                .catch(err => console.log(err))       
            }
            else if(props.associatedGroupingType === "project" &&
                props.type === 'final_presentation' && 
                event.target.files.length > 0)
            {
                if(event.target.files[0].type !== 'application/pdf' && event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation'){
                    event.target.value = null;
                    alert("Invalid File Type: Please Upload PDF and PPTX Files Only.");
                    return;
                }

                const formData = new FormData();
                
                formData.append('end_semester', props.group.project.end_semester);
                formData.append('year', year);
                formData.append('type', props.type);

                formData.append('file', event.target.files[0]);
                formData.append('filename', event.target.files[0].name);
                formData.append('filetype', event.target.files[0].type);
                formData.append('filesize', event.target.files[0].size);
                formData.append('hidden', 0);
                
                axios.post(`${process.env.REACT_APP_API_HOST}/api/file/uploadGroupFiles`,
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                        Authorization: `Bearer ${props.token.access_token}`,
                    },
                })        
                .then(res => props.filesLoaded(res.data.data[0], props.type))
                .catch(err => console.log(err))       
            }
            else if(props.associatedGroupingType === "project" &&
                props.type === 'photo' && 
                event.target.files.length > 0)
            {
                if(event.target.files[0].type !== 'image/jpeg' && event.target.files[0].type !== 'image/png'){
                    event.target.value = null;
                    alert("Invalid File Type: Please Upload JPEG and PNG Files Only.");
    
                    return;
                }
                setFile(event.target.files[0])
                const formData = new FormData();

                formData.append('end_semester', props.group.project.end_semester);
                formData.append('year', year);
                formData.append('type', props.type);

                formData.append('file', event.target.files[0]);
                formData.append('filename', event.target.files[0].name);
                formData.append('filetype', event.target.files[0].type);
                formData.append('filesize', event.target.files[0].size);
                formData.append('hidden', 0);
                
                axios.post(`${process.env.REACT_APP_API_HOST}/api/file/uploadGroupImage`,
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                        Authorization: `Bearer ${props.token.access_token}`,
                    },
                })        
                .then(res => props.filesLoaded(res.data.data[0], props.type))
                .catch(err => console.log(err))       

            }
            else if(props.associatedGroupingType == "project" && event.target.files.length > 0){

                const formData = new FormData();
                formData.append('user_id', 0);
                formData.append('project_id', project_id);
                formData.append('start_semester', props.selectedClass.startSemester);
                formData.append('year', year);

                for(let i = 0; i < event.target.files.length; i++){
                                
                    formData.append('file', event.target.files[i]);
                    formData.append('filename', event.target.files[i].name);
                    formData.append('filetype', event.target.files[i].type);
                    formData.append('filesize', event.target.files[i].size);
                    formData.append('hidden', 0);
                    formData.append('type', props.type);
                }
                formData.append('numFiles', event.target.files.length);

                props.updateForm(formData)

            }
            // console.log(event.target.files[0])
            else if(event.target.files[0].type === 'application/pdf' && props.associatedGroupingType === "student"){
    
                const formData = new FormData();
                formData.append('semester', props.semester); 
                formData.append('file', event.target.files[0]); 
                formData.append('filename', event.target.files[0].name); 
                formData.append('filetype', event.target.files[0].type); 
                formData.append('filesize', event.target.files[0].size); 
                formData.append('hidden', 0); 
                formData.append('type', type); 
                formData.append('year', year);
                        
                axios.post(`${process.env.REACT_APP_API_HOST}/api/file/uploadStudentFile`,
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                        Authorization: `Bearer ${props.token.access_token}`,
                    },
                })        
                .then(res => props.filesLoaded(res.data.data, props.type))
                .catch(err => console.log(err))       
                
                return;
            }else{
                event.target.value = null;
                alert("Invalid File Type: Please Upload PDF File Only.");
            }         
        }catch(err){
            console.log("Error caught." + 
                "This may have been when file was added " + 
                "to upload: " + err);
        }   
    }

  return (
        
        <div id="upload-box">
            {props.singleMultiple == "single" ?
                <input type="file" onChange={checkFile} accept='application/pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/*'/>
                :
                <div>
                    <input multiple type="file" onChange={checkFile} accept='application/pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/*'/>
                </div>
                
            }
        </div>

  )
}

export default FileUploadButton